import React, { Component } from "react";
import MainNavbar from "../components/navbar/navbar";
import Home from "../components/homepage";
import Membersite from "../components/memberpage";
import { Route, Switch, withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { isLoaded } from "react-redux-firebase";
import LoadingPage from "../components/loadingpage";
import SuccessSnackbar from "../components/snackbar/successSnackbar";
import WhatsAppButton from "../components/whatsappButton/whatsappButton";
/* import Checkout from "../components/checkout"; */
import Agenda from "../components/agenda";
import CourseDetail from "../components/courses/courseDetail";
import Store from "../components/store/store";
import StoreItemDetail from "../components/store/storeItemDetail";
import Retreats from "../components/retreats";
import RetreatDetail from "../components/retreats/retreatDetail";

function AuthIsLoaded({ children }) {
  const auth = useSelector((state) => state.firebaseState.auth);
  if (!isLoaded(auth)) return <LoadingPage></LoadingPage>;
  return children;
}
class App extends Component {
  componentDidMount() {
    // Handle Safari hash scroll issue when navigating from different route
    this.handleSafariHashScroll();
  }

  componentDidUpdate(prevProps) {
    // Handle hash scroll when route changes (e.g., from /store to /#camino)
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.handleSafariHashScroll();
    }
  }

  handleSafariHashScroll = () => {
    // Check if we're on Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    if (!isSafari) return;

    const hash = window.location.hash;
    if (hash && this.props.location.pathname === '/') {
      // Prevent Safari's automatic scroll
      if (window.history.scrollRestoration) {
        window.history.scrollRestoration = 'manual';
      }
      
      // Immediately prevent any scrolling
      window.scrollTo(0, 0);
      
      // Wait for page to fully load including images
      const checkAndScroll = () => {
        if (document.readyState === 'complete') {
          // Wait a bit more for React to render
          setTimeout(() => {
            this.scrollToHash(hash);
          }, 200);
        } else {
          window.addEventListener('load', () => {
            setTimeout(() => {
              this.scrollToHash(hash);
            }, 200);
          });
        }
      };
      
      // If page is already loaded, scroll immediately after render
      if (document.readyState === 'complete') {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            checkAndScroll();
          });
        });
      } else {
        window.addEventListener('load', checkAndScroll);
      }
    }
  };

  scrollToHash = (hash) => {
    const element = document.querySelector(hash);
    if (element) {
      // Get navbar height
      const navbar = document.querySelector('.navbar');
      const navbarHeight = navbar ? navbar.offsetHeight : 0;
      
      // Since the anchor is on a <br> tag, we might need to scroll to the next element
      // or use offsetTop which is more reliable for <br> tags
      let scrollPosition;
      
      // Try to get position from the element itself
      if (element.offsetTop !== undefined) {
        scrollPosition = element.offsetTop - navbarHeight;
      } else {
        // Fallback to getBoundingClientRect
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        scrollPosition = rect.top + scrollTop - navbarHeight;
      }
      
      // Ensure we don't scroll to negative position
      scrollPosition = Math.max(0, scrollPosition);
      
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });
    }
  };

  render() {
    return (
      <AuthIsLoaded>
        <SuccessSnackbar />
        <MainNavbar />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/agenda" component={Agenda} />
          <Route path="/membersite" component={Membersite} />
          <Route path="/course/:id" component={CourseDetail} />
          <Route exact path="/retreats" component={Retreats} />
          <Route exact path="/retreats/:id" component={RetreatDetail} />
          <Route path="/store/:itemName" component={StoreItemDetail} />
          <Route path="/store" component={Store} />
          {/* <Route path="/checkout" component={Checkout} /> */}
        </Switch>
        <WhatsAppButton />
      </AuthIsLoaded>
    );
  }
}

export default withRouter(App);

